import { render, staticRenderFns } from "./ErrorBar.vue?vue&type=template&id=604697b6&scoped=true&"
import script from "./ErrorBar.vue?vue&type=script&lang=ts&"
export * from "./ErrorBar.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorBar.vue?vue&type=style&index=0&id=604697b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604697b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VRow})
